(function (module) {
    module.service('ImageTransformer', ['EmarketConstant', function (EmarketConstant) {
        var sizes = {
            thumbnail: '60x36',
            small: '240x144',
            square: '350x350',
            large: '840x504'
        };
        return {
            get: function (path, size) {
                var err;
                if (!size) {
                    throw new Error('You must past a least one of the different sizes types [thumbnail, small, square, large]');
                }
                if (!sizes[size]) {
                    throw new Error('Invalid Size ' + size);
                }
                var regex = /\.\w{3}$/;
                if (path) {
                    //get the ext
                    var match = path.match(regex);
                    var ext = match[0];

                    image = path.replace(regex, '_' + size) + ext;
                    image = EmarketConstant.path + '/' + image;
                    return image;
                } else {
                    throw new Error('Missing image path');
                }

            },
            LARGE: 'large',
            SMALL: 'small',
            SQUARE: 'square',
            THUMBNAIL: 'thumbnail'
        };
    }]);
}(angular.module('emarket.commons')));
